export const removeFalsyValues = (obj) => {
    return Object.fromEntries(Object.entries(obj).filter(([, value]) => Boolean(value)));
};
export const transformDataWithConsents = (data, consents) => {
    if (!consents.length) {
        return data;
    }
    const consentPurposes = consents.map((consent) => ({
        accepted: data[consent.id] === true,
        id: consent.id,
    }));
    const result = {
        ...data,
        consent_purposes: consentPurposes,
    };
    consents.forEach((consent) => {
        delete result[consent.id];
    });
    return result;
};
//# sourceMappingURL=helpers.js.map